const doc = [({"en":({"js":({"users":({"edit":({"form":({"index":({"no_longer_in_school":"I'm no longer in school"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;